import { useQuery } from '@tanstack/react-query';
import axios from '../../../../common/api/request';
import { SamplingPlanningResponse } from './types';

interface UseSamplingPlanningDataParams {
  enabled?: boolean;
}

export function useSamplingPlanningData({ enabled = true }: UseSamplingPlanningDataParams = {}) {
  return useQuery({
    queryKey: ['sampling-planning-data'],
    queryFn: async (): Promise<SamplingPlanningResponse> => {
      const response = await axios.get('/sampling-planning');
      return response.data;
    },
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
} 